<template>
  <div class="form" v-loading="loading">
    <breadcrumb :breadcrumb="breadcrumb"></breadcrumb>
    <div class="button_wrap">
      <el-button type="primary" class="btn" @click="saveData">{{
        language("companyInformation.save")
      }}</el-button>
    </div>
    <el-tabs v-model="activeName" v-if="!loading">
      <el-tab-pane :label="language('companyInformation.tab1')" name="tab1">
        <el-form
          ref="form"
          label-width="270px"
          label-position="left"
          :model="formData"
          :rules="rules"
        >
          <!-- <tab1-v2 v-model="formData"></tab1-v2> -->
          <tab1 v-model="formData"></tab1>
        </el-form>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import breadcrumb from "../../components/breadcrumb";
import tab1V2 from "./components/tab/tab1V2";
import tab1 from "./components/tab/tab1";

export default {
  components: {
    breadcrumb,
    tab1V2,
    tab1,
  },
  data() {
    return {
      loading: true,
      activeName: "tab1",
      formData: {},
      // playloadField: 確保提交表單只能提交這些字段
      playloadField: [
        "nameEng",
        "nameChi",
        "registerArea",
        "registerNum",
        "country",
        "region",
        "street",
        "room",
        "brCertificateNum",
        "brCertificateUrl",
        "brExpiryDate",
        "introductionUrl",
        "businessEmail",
        "contactFirstName",
        "contactLastName",
        "contactPosition",
        "contactDepartment",
        "contactEmail",
        "contactPersonalPhone",
        "officePhoneNumber",
        "fax",
      ],
      breadcrumb: {
        title: this.language("companyInformation.breadcrumbTitle"),
        list: [
          {
            name: this.language("companyInformation.breadcrumbList_1"),
          },
          {
            name: this.language("companyInformation.breadcrumbList_2"),
          },
        ],
      },
      rules: {
        nameEng: [
          {
            required: true,
            message: this.language("companyInformation.nameEngTips"),
          },
        ],
        nameChi: [
          {
            required: true,
            message: this.language("companyInformation.nameChiTips"),
            trigger: "change",
          },
        ],
        registerArea: [
          {
            required: true,
            message: this.language("companyInformation.registerAreaTips"),
            trigger: "change",
          },
        ],
        registerNum: [
          {
            required: true,
            message: this.language("companyInformation.registerNumTips"),
            trigger: "change",
          },
        ],
        country: [
          {
            required: true,
            message: this.language("companyInformation.countryTips"),
            trigger: "change",
          },
        ],
        region: [
          {
            required: true,
            message: this.language("companyInformation.regionTips"),
            trigger: "change",
          },
        ],
        street: [
          {
            required: true,
            message: this.language("companyInformation.streetTips"),
            trigger: "change",
          },
        ],
        room: [
          {
            required: true,
            message: this.language("companyInformation.roomTips"),
            trigger: "change",
          },
        ],
        brCertificateNum: [
          {
            required: true,
            message: this.language("companyInformation.brCertificateNumTips"),
            trigger: "change",
          },
        ],
        brCertificateUrl: [
          {
            required: true,
            message: this.language("companyInformation.brCertificateUrlgTips"),
            trigger: "change",
          },
        ],
        brExpiryDate: [
          {
            required: true,
            message: this.language("companyInformation.brExpiryDateTips"),
            trigger: "change",
          },
        ],
        introductionUrl: [
          {
            required: true,
            message: this.language("companyInformation.introductionUrlTips"),
            trigger: "change",
          },
        ],
        businessEmail: [
          {
            required: true,
            message: this.language("companyInformation.businessEmailTips"),
            trigger: "change",
          },
        ],
        contactFirstName: [
          {
            required: true,
            message: this.language("companyInformation.contactFirstNameTips"),
            trigger: "change",
          },
        ],
        contactLastName: [
          {
            required: true,
            message: this.language("companyInformation.contactLastNameTips"),
            trigger: "change",
          },
        ],
        contactPosition: [
          {
            required: true,
            message: this.language("companyInformation.contactPositionTips"),
            trigger: "change",
          },
        ],
        contactDepartment: [
          {
            required: true,
            message: this.language("companyInformation.contactDepartmentTips"),
            trigger: "blur",
          },
        ],
        contactEmail: [
          {
            required: true,
            message: this.language("companyInformation.contactEmailTips"),
            // pattern: /^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/,
            trigger: "blur",
          },
        ],
        contactPersonalPhone: [
          {
            required: true,
            message: this.language(
              "companyInformation.contactPersonalPhoneTips"
            ),
            trigger: ["blur"],
          },
        ],
        officePhoneNumber: [
          {
            required: true,
            message: this.language("companyInformation.officePhoneNumberTips"),
            trigger: "blur",
          },
        ],
        isAgreeHktv: [
          {
            required: true,
            message: this.language("companyInformation.isAgreeHktvTips"),
            trigger: "blur",
          },
        ],
        productCategory: [
          {
            required: true,
            message: this.language("companyInformation.productCategoryTips"),
            trigger: "blur",
          },
        ],
        productSaleCount: [
          {
            required: true,
            message: this.language("companyInformation.productSaleCountTips"),
            trigger: "blur",
          },
        ],
        // fax: [{ required: true, message: '不能為空' }],
      },
    };
  },
  methods: {
    saveData() {
       console.log(this.formdata);
      this.$refs["form"].validate(async (valid) => {
        if (valid) {
          let formdata = { ...this.formData };
    
          try {
            const res = await this.ccRequest.do(
              "admin/merchant/save",
              formdata,
              "POSTJSON"
            );
            this.$message.success(this.language("companyInformation.success"));
          } catch (err) {
            this.$message.error(err.response.data.message);
          }
        } else {
          this.$message.error(this.language("companyInformation.err"));
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
  mounted() {
    let shopData = this.storage.getStorage("shop");
    this.ccRequest
      .do(
        "admin/merchant/getMerchantInfo",
        { merchantNum: shopData.merchantNum },
        "GET"
      )
      .then((res) => {
        // this.formData = res;
        // 对象改变后进行深度响应
        Object.keys(res).forEach((key) =>
          this.$set(this.formData, key, res[key])
        );
        this.loading = false;
      })
      .catch((err) => {
        this.loading = false;
        this.$message.error(err.response.data.message);
      });
  },
};
</script>
<style scoped lang="scss">
.form {
  min-height: 80vh;
}
.button_wrap {
  width: 150px;
  position: absolute;
  top: 40px;
  right: 100px;
  .btn {
    width: 100%;
  }
}
</style>
